import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

const data = [
  {
    name: "Priya Kulkarni",
    role: "Mother of two, Pune",
    quote:
      "We did two sonographies and a full blood panel last month. The membership paid for itself in a single visit — and I got the card on WhatsApp instantly.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=160&h=160&fit=crop",
    rating: 5,
  },
  {
    name: "Rohit Deshmukh",
    role: "Engineer, Mumbai",
    quote:
      "Booked an MRI for my dad and saved a meaningful amount. The Razorpay flow was clean and the card looks genuinely premium.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=160&h=160&fit=crop",
    rating: 5,
  },
  {
    name: "Dr. Anjali Rao",
    role: "GP, 1Rupee Clinic",
    quote:
      "Patients walk in confidently with the membership number on their phone. Verification at billing is now under 5 seconds.",
    avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=160&h=160&fit=crop",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">
            Loved by families
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
            Stories from our <span className="text-gradient-aqua">members.</span>
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {data.map((t) => (
            <Card
              key={t.name}
              className="relative p-7 border-border/60 bg-card hover:shadow-elegant transition-shadow duration-300 flex flex-col"
            >
              <Quote className="absolute top-5 right-5 h-7 w-7 text-primary/15" />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-warning text-warning" />
                ))}
              </div>
              <CardContent className="p-0 flex-1 flex flex-col">
                <p className="text-sm sm:text-[15px] text-foreground/90 leading-relaxed">
                  “{t.quote}”
                </p>
                <div className="mt-auto pt-6 flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="h-10 w-10 rounded-full object-cover ring-2 ring-primary/15"
                  />
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-foreground truncate">{t.name}</div>
                    <div className="text-xs text-muted-foreground truncate">{t.role}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
